<div class="overlayDiv row align-items-center">
    <div class="col-auto">
        <h5 class="mb-0">Funded: {{fundedCount}} ({{fundedAmount | currency}})</h5>
        <span style="font-size: small;">Last refreshed: {{displayTime | date: 'dd-MM-yyyy H:mm'}}</span>
    </div>
    <div class="col-auto field-sm">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Referral Date</mat-label>
            <input matInput [matDatepicker]="referralDatePicker" [(ngModel)]="referralDateSearch" (ngModelChange)="refreshGrid()">
            <mat-datepicker-toggle matIconSuffix [for]="referralDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #referralDatePicker></mat-datepicker>
        </mat-form-field>
    </div>
    <!-- <div class="col-auto field-sm ">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Name</mat-label>
            <input matInput type="text" placeholder="Search name..." [(ngModel)]="nameSearch" (ngModelChange)="refreshGrid()">
        </mat-form-field>
    </div> -->
    <div class="col-auto field-sm ">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Debtor Number</mat-label>
            <input matInput type="text" placeholder="Search debtor number..." [(ngModel)]="debtorNumberSearch" (ngModelChange)="refreshGrid()">
        </mat-form-field>
    </div>
    <div class="col-auto field-sm">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Collector</mat-label>
            <input matInput type="text" placeholder="Search collector..." [(ngModel)]="collectorSearch" (ngModelChange)="refreshGrid()">
        </mat-form-field>
    </div>
    <div class="col-auto field-sm">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Creditor</mat-label>
            <input matInput type="text" placeholder="Search creditor..." [(ngModel)]="creditorSearch" (ngModelChange)="refreshGrid()">
        </mat-form-field>
    </div>
    <div class="col-auto" style="min-width: 260px;">
        <app-multi-select-search
            [items]="stageOptions"
            [selected]="selectedStages"
            fieldClass="field-sm"
            label="Stage"
            searchPlaceholder="Search stages..."
            (selectionChange)="onStageFilterChange($event)">
        </app-multi-select-search>
    </div>
</div>
<div class="row custom-media-size" style="height: calc(100% - 60px);">
    <app-custom-table class="ag-theme-material" class="collection-wrapper" [rowData]="gridApi_agency_data"
        [columnDefs]="columnDefs_agency" [hideGlobalFilter]="true" [animateRows]="true" [pagination]="true"
        [showToolPanel]="true" 
        [paginationPageSize]="20" [rowClassRules]="rowClassRules" (gridReady)="onGridReady($event)" (cellClicked)="onCellClicked($event)"
        [showLoader]="showLoader" (filterReset)="onResetFilters()">
    </app-custom-table>
</div>